import {
  GET_LEGALPEIL,
  GET_LEGALPEIL_SUCCESS,
  GET_LEGALPEIL_FAIL,
  DELETE_LEGALPEIL,
  DELETE_LEGALPEIL_SUCCESS,
  DELETE_LEGALPEIL_FAIL,
  UPDATE_LEGALPEIL,
  UPDATE_LEGALPEIL_SUCCESS,
  UPDATE_LEGALPEIL_FAIL,
  ADD_NEW_LEGALPEIL,
  ADD_LEGALPEIL_SUCCESS,
  ADD_LEGALPEIL_FAIL,
  LEGALPEIL_LOADING,
  LEGALPEIL_RESET
} from "./actionType";

export const resetLegalPeilState = (actionType) => ({
  type: LEGALPEIL_RESET,
  payload: { actionType },
});

export const getLegalPeilSuccess = (actionType, data) => ({
  type: GET_LEGALPEIL_SUCCESS,
  payload: { actionType, data },
});

export const getLegalPeilFail = (actionType, error) => ({
  type: GET_LEGALPEIL_FAIL,
  payload: { actionType, error },
});

export const getLegalPeil = data => ({
  type: GET_LEGALPEIL,
  payload: data,
});

export const getLegalPeilLoading = () => ({
  type: LEGALPEIL_LOADING
});

export const deleteLegalPeil = data => ({
  type: DELETE_LEGALPEIL,
  payload: data,
});

export const deleteLegalPeilSuccess = data => ({
  type: DELETE_LEGALPEIL_SUCCESS,
  payload: data,
});

export const deleteLegalPeilFail = error => ({
  type: DELETE_LEGALPEIL_FAIL,
  payload: error,
});

export const updateLegalPeil = data => ({
  type: UPDATE_LEGALPEIL,
  payload: data,
});

export const updateLegalPeilFail = error => ({
  type: UPDATE_LEGALPEIL_FAIL,
  payload: error,
});

export const updateLegalPeilSuccess = data => ({
  type: UPDATE_LEGALPEIL_SUCCESS,
  payload: data,
});

export const addNewLegalPeil = data => ({
  type: ADD_NEW_LEGALPEIL,
  payload: data,
});

export const addLegalPeilSuccess = data => ({
  type: ADD_LEGALPEIL_SUCCESS,
  payload: data,
});

export const addLegalPeilFail = error => ({
  type: ADD_LEGALPEIL_FAIL,
  payload: error,
});